const formEl = document.querySelector('#warranty-registration-form');
const firstNameEl = document.querySelector('#first-name');
const lastNameEl = document.querySelector('#last-name');
const emailEl = document.querySelector('#email');
const phoneNumberEl = document.querySelector('#phone-number');
const productEl = document.querySelector('#product');
const colorEl = document.querySelector('#color');
const serialNumberEl = document.querySelector('#serial-number');
const purchasedFromEl = document.querySelector('#purchased-from');
const dateOfPurchaseEl = document.querySelector('#date-of-purchase');
const orderNumberEl = document.querySelector('#order-number');
const placeOfPurchaseEl = document.querySelector('#place-of-purchase');
const proofOfPurchaseEl = document.querySelector('#proof-of-purchase');
const submitButtonEl = document.querySelector('#submit-warranty-registration-form-button');
const successMessageEl = document.querySelector('#success-message');

async function handleFormSubmit(event) {
  event.preventDefault();
  submitButtonEl.disabled = true;

  const first_name = firstNameEl.value.trim();
  const last_name = lastNameEl.value.trim();
  const email = emailEl.value.trim();
  const phone_number = phoneNumberEl.value.trim();
  const product = productEl.value.trim();
  const color = colorEl.value.trim();
  const serial_number = serialNumberEl.value.trim();
  const purchased_from = purchasedFromEl.value.trim();
  const date_of_purchase = dateOfPurchaseEl.value.trim();
  const order_number = orderNumberEl.value.trim();
  const place_of_purchase = placeOfPurchaseEl.value.trim();
  const proof_of_purchase = proofOfPurchaseEl.files[0];

  if (proof_of_purchase) {
    const maxSize = 25 * 1024 * 1024; // 25MB
    if (proof_of_purchase.size > maxSize) {
      alert('The file size is too large. Please upload a file that is less than 25MB.');
      proofOfPurchaseEl.value = null;
      submitButtonEl.disabled = false;
      return;
    }
  }

  if (
    first_name &&
    last_name &&
    email &&
    phone_number &&
    product &&
    serial_number &&
    purchased_from &&
    date_of_purchase
  ) {
    const formData = new FormData();
    formData.append('first_name', first_name);
    formData.append('last_name', last_name);
    formData.append('email', email);
    formData.append('phone_number', phone_number);
    formData.append('product', product);
    formData.append('color', color);
    formData.append('serial_number', serial_number);
    formData.append('purchased_from', purchased_from);
    formData.append('date_of_purchase', date_of_purchase);
    formData.append('order_number', order_number);
    formData.append('place_of_purchase', place_of_purchase);
    formData.append('proof_of_purchase', proof_of_purchase);

    const originUrl = window.location.origin;
    const apiUrl = originUrl === 'https://kiarasky.com' ? 'https://sleepy-ridge-54731-86f3fc602d40.herokuapp.com' : 'http://localhost:8080';
    console.log(apiUrl);

    const response = await fetch(`${apiUrl}/api/warranty/registrations`, {
      method: 'POST',
      body: formData,
    });

    if (response.ok) {
      formEl.classList.add('d-none');
      successMessageEl.classList.remove('d-none');
      window.location.assign('/pages/registration-complete');
    } else {
      alert('An error occurred while registering your warranty. Please try again later.');
    }
  }
}

function handleProductChange(event) {
  const value = event.target.value;
  const productsWithColor = [
    'Rechargeable LED Lamp',
    'Rechargeable LED 3',
    'Portable Nail Drill',
    'Nail Dust Collector',
    'Beyond Home LED Lamp',
  ];

  if (productsWithColor.includes(value)) {
    colorEl.parentElement.classList.remove('d-none');
    colorEl.required = true;
  } else {
    colorEl.parentElement.classList.add('d-none');
    colorEl.required = false;
  }
}

function handlePurchasedFromChange(event) {
  const value = event.target.value;

  if (value === 'KiaraSky.com') {
    orderNumberEl.parentElement.classList.remove('d-none');
    placeOfPurchaseEl.parentElement.classList.add('d-none');
    proofOfPurchaseEl.parentElement.classList.add('d-none');

    orderNumberEl.required = true;
    placeOfPurchaseEl.required = false;
    proofOfPurchaseEl.required = false;
  } else if ('Distributor') {
    orderNumberEl.parentElement.classList.add('d-none');
    placeOfPurchaseEl.parentElement.classList.remove('d-none');
    proofOfPurchaseEl.parentElement.classList.remove('d-none');

    orderNumberEl.required = false;
    placeOfPurchaseEl.required = true;
    proofOfPurchaseEl.required = true;
  }

  submitButtonEl.disabled = false;
}

purchasedFromEl.addEventListener('change', handlePurchasedFromChange);
productEl.addEventListener('change', handleProductChange);
formEl.addEventListener('submit', handleFormSubmit);
